<template>
    <p v-if="!customMessage">
      <span v-if="confirmationMessageStatus">{{Lang.get('messages.delete_confirmation')}} (</span>
      <span v-if="message">
        {{message}}
        </span> <span v-if="confirmationMessageStatus">){{Lang.get('messages.question_mark')}}</span>
    </p>

    <p v-else>
      <span>
        {{customMessage}}
      </span>
    </p>
</template>

<script>
    export default {
      props: {
        message:{
          type: [String],
          required:false,
          default:''
        },
        customMessage:{
          type: [String],
          required:false,
          default:''
        },
        confirmationMessageStatus:{
          type:[Boolean],
          required:false,
          default:true
        }
      }
    };

</script>

<style>
</style>
